import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuardService } from '@zc/auth';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('@zc/auth-pages').then((m) => m.AuthPagesModule) },
  {
    path: 'admin',
    canActivate: [AdminGuardService],
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: `reload` })],
})
export class AppRoutingModule {}
